import React, { useEffect } from 'react';
import { Content, Header, List, Title, Wrapper } from './list-preview-approval-employee-requests.styles';
import { ArrowsChevronRight } from '@vtbhome/juicyfront/indexIcon';
import { Tag } from '@vtbhome/juicyfront';
import { Typography } from '@shared/ui/typography/typography';
import { ROUTE_ADMIN_APPROVE_REQUESTS } from '@shared/config/routes/routes';
import { COLORS } from '@shared/config/colors/colors';
import { DeclineEmployeeRequest } from '@features/request/decline-employee-request/ui/decline-employee-request';
import { useRequestsListSharedQuery } from '@entities/request/libs/hooks/use-request-list-shared-query/use-request-list-shared-query';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { RequestsListDataRequest } from '@entities/request/api/request-types';
import { dateStart } from '@shared/lib/utils/date/date';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { DEFAULT_REQUESTS_LIST_PARAMETERS } from '@entities/request/config/store-constants';
import { CardApprovalEmployeeRequestPreview } from '@entities/request/ui/card-approval-employee-request-preview/card-approval-employee-request-preview';
import { NetworkStateNew } from '@shared/ui/network-state-new/network-state-new';
import { RequestStatus } from '@shared/model/request';
import { useSearchParams } from '@shared/lib/hooks/use-search-params/use-search-params';
import { LinkScroll } from '@shared/ui/link-scroll/link-scroll';

export const ListPreviewApprovalEmployeeRequests: React.FC = () => {
    const user = useCurrentUserSelector();

    const [parameters, setParameters] = useSearchParams<RequestsListDataRequest>({
        ...DEFAULT_REQUESTS_LIST_PARAMETERS,
        userId: user?.id || 0,
        companyId: user?.company?.id || 0,
        statuses: RequestStatus.New,
        take: 3,
    });

    const [getRequestsList, getRequestsListResult, handleResetCache] = useRequestsListSharedQuery(parameters);

    const requestsData = getRequestsListResult.data;
    const requestsTotalCount = requestsData?.total;
    const error = getQueryError(getRequestsListResult);

    const handleSuccess = async () => {
        handleResetCache();
        setParameters({ ...parameters });
    };

    useEffect(() => {
        getRequestsList(parameters);
    }, [parameters]);

    return (
        <Wrapper>
            <Header>
                <Title>
                    <Typography size='h6'>Запросы к согласованию</Typography>
                    {Boolean(requestsData) && <Tag variant='blue'>{requestsTotalCount}</Tag>}
                </Title>
                <LinkScroll to={`${ROUTE_ADMIN_APPROVE_REQUESTS}`}>
                    <ArrowsChevronRight color={COLORS.neutral_50} />
                </LinkScroll>
            </Header>
            <Content>
                <NetworkStateNew
                    isLoading={
                        getRequestsListResult.isLoading ||
                        getRequestsListResult.isFetching ||
                        getRequestsListResult.isUninitialized
                    }
                    isInitialized={Boolean(requestsData)}
                    isError={Boolean(error)}
                    isFiltered={false}
                    hasData={Boolean(requestsData?.items?.length)}
                    errorProps={{
                        title: 'Ошибка загрузки запросов',
                        description: error?.message,
                    }}
                    emptyProps={{
                        title: 'Новые запросы отсутствуют',
                    }}>
                    <List>
                        {requestsData?.items?.map((request) => (
                            <CardApprovalEmployeeRequestPreview
                                key={request.id}
                                date={dateStart(request.createdAt)}
                                productName={request.product.name}>
                                <DeclineEmployeeRequest request={request} onSuccess={handleSuccess} />
                            </CardApprovalEmployeeRequestPreview>
                        ))}
                    </List>
                </NetworkStateNew>
            </Content>
        </Wrapper>
    );
};
